var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Icon',{attrs:{"icon":_vm.icon(_vm.status),"iconColor":_vm.isHeader ? 'tertiary' : _vm.color(_vm.status),"tooltipColor":_vm.isHeader ? 'primary' : undefined,"tooltipText":_vm.statusLabels[_vm.status],"small":!_vm.isHeader,"margin":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }